import { useState } from 'react';

import { Stack, Title } from 'ui';

import { PendoAnnouncements } from './PendoAnnouncements/PendoAnnouncements';

const AnnouncementCenter = () => {
  const [announcementCount, setAnnouncementCount] = useState(0);

  return (
    <Stack display={announcementCount < 1 ? 'none' : 'flex'}>
      {announcementCount > 0 && (
        <Title order={2} fz={24}>
          Announcements!
        </Title>
      )}
      <PendoAnnouncements setAnnouncementCount={setAnnouncementCount} />
    </Stack>
  );
};

export { AnnouncementCenter };
